// src/config.js
// Production: REACT_APP_API_URL, or same-origin /api-server if it is missing or invalid.
// Development: localhost when the env var is missing or invalid.
const PRODUCTION_API_FALLBACK = '/api-server';
const DEV_API = 'http://localhost:5002';

// Clerk publishable key from dashboard.clerk.com > API Keys
export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';

const isValidApiUrl = (url) => typeof url === 'string' && url.startsWith('http');

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL?.trim();
  if (isValidApiUrl(envUrl)) return envUrl;

  const isProduction = process.env.NODE_ENV === 'production';
  if (!envUrl && isProduction) {
    console.warn(
      'REACT_APP_API_URL is missing. Using same-origin /api-server. Set REACT_APP_API_URL to the backend URL (https://www.ministrydataportal.com/api-server in production).'
    );
  } else if (envUrl) {
    console.warn(
      `REACT_APP_API_URL is invalid ("${envUrl}"). Using ${isProduction ? 'same-origin /api-server' : DEV_API}. Set it to an http(s) URL.`
    );
  }

  return isProduction ? PRODUCTION_API_FALLBACK : DEV_API;
};

export const API_BASE_URL = getApiBaseUrl();
